import { MesfModal } from "@dexteel/mesf-core";
import { Button } from "@mui/material";

import { CampaignResponse } from "@/pages/mill/schedule/models/CampaignReponse";
import { MillId } from "@/setup/mill-config/mill-config";
import { MechanicalResultsContent } from "./MechanicalResultsContent";

export {
	useHeatMechanicalResult,
	useHeatTestDisposition,
} from "./MechanicalResultsContent";

type Props = {
	heat: CampaignResponse | null;
	onHide: () => void;
	millId?: MillId;
	canEdit?: boolean;
};

export const MechanicalResultsModal = ({
	heat,
	onHide,
	millId,
	canEdit,
}: Props) => (
	<MesfModal
		open={heat !== null}
		handleClose={onHide}
		id="mechanical-results-modal"
		maxWidth="lg"
		title={`MECHANICAL TESTS - HEAT ${heat?.HeatName ?? "-"}`}
		subtitle={`Grade: ${heat?.GradeName ?? "-"}`}
	>
		<MesfModal.Content style={{ padding: "15px 30px" }}>
			<MechanicalResultsContent heat={heat} millId={millId} canEdit={canEdit} />
		</MesfModal.Content>
		<MesfModal.Actions style={{ padding: "10px 30px 20px" }}>
			<Button onClick={onHide} variant="contained" color="inherit">
				Close
			</Button>
		</MesfModal.Actions>
	</MesfModal>
);
